import {PageCenteredSpinner} from '@/componentLibrary/components/spinners/PageCenteredSpinner';
import {useSsoHandler} from '@/pages/Login/hooks/useSsoHandler';

export function VerifyOidcAuthentication() {
    useSsoHandler();

    return <PageCenteredSpinner />;
}
